module.exports = __webpack_public_path__ + "media/icons/formula-21323504.svg";